import { ApolloProvider } from '@apollo/client'
import { Web3ReactProvider } from '@web3-react/core'
import { providers } from 'ethers'
import React, { useContext } from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'
import './App.scss'
import { Header } from './components/Header'
import { HamburgerProvider } from './components/Header/HamburgerContext'
import { RefreshOnAccountChange } from './components/RefreshOnAccountChange'
import { ArcContext, ArcProvider } from './contexts/ArcContext'
import { ServiceContext } from './contexts/ServicesContext'
import { AllPositions } from './pages/AllPositions'
import { ClaimPage } from './pages/ClaimPage'
import { CurvePage } from './pages/CurvePage'
import { DashboardPage } from './pages/DashboardPage'
import { FarmsPage } from './pages/FarmsPage'
import { LeaderBoardPage } from './pages/LeaderBoardPage'
import { NewPosition } from './pages/NewPosition/NewPosition'
import { Phase1SalePage } from './pages/Phase1SalePage'
import { Phase2AllocationPage } from './pages/Phase2AllocationPage'
import { Phase2SalePage } from './pages/Phase2SalePage/Phase2SalePage'
import { PositionPage } from './pages/PositionPage'
import { ProfilePage } from './pages/ProfilePage'
import { SavingsPage } from './pages/SavingsPage'
import { SingleFarmPage } from './pages/SingleFarmPage'
import { createServices } from './services'

function getLibrary(provider: providers.ExternalProvider) {
  const library = new providers.Web3Provider(provider)
  library.pollingInterval = 2000
  return library
}

function App() {
  return (
    <Web3ReactProvider getLibrary={getLibrary}>
      <ServiceContext.Provider value={createServices()}>
        <ArcProvider>
          <AppData />
        </ArcProvider>
      </ServiceContext.Provider>
    </Web3ReactProvider>
  )
}

function AppData() {
  const { client, network } = useContext(ArcContext)

  const signInMessage = (
    <div className="app__sign-in-container">
      <h2>
        Please connect your wallet
        <br />
        💳
      </h2>
    </div>
  )

  return (
    <ApolloProvider client={client}>
      <HamburgerProvider>
        <Router>
          <RefreshOnAccountChange>
            <div className="app">
              {/* <Scroller /> */}
              <Header />
              {!network ? (
                signInMessage
              ) : (
                <Switch>
                  <Route exact path="/">
                    <Redirect to="/dashboard" />
                  </Route>
                  <Route exact path="/mint">
                    <NewPosition />
                  </Route>
                  <Route path="/vaults/:id">
                    <PositionPage />
                  </Route>
                  <Route exact path="/vaults">
                    <AllPositions />
                  </Route>
                  <Route exact path="/profile">
                    <ProfilePage />
                  </Route>
                  <Route exact path="/farms/:farmName">
                    <SingleFarmPage />
                  </Route>
                  <Route exact path="/farms">
                    <FarmsPage />
                  </Route>
                  <Route exact path="/leaderboard">
                    <LeaderBoardPage />
                  </Route>
                  <Route path="/savings">
                    <SavingsPage />
                  </Route>
                  <Route path="/dashboard">
                    <DashboardPage />
                  </Route>
                  <Route path="/phase1-sale">
                    <Phase1SalePage />
                  </Route>
                  <Route path="/phase2-sale">
                    <Phase2SalePage />
                  </Route>
                  <Route path="/phase2-allocations">
                    <Phase2AllocationPage />
                  </Route>
                  <Route exact path="/exchange">
                    <CurvePage />
                  </Route>
                  <Route exact path="/token-claim">
                    <ClaimPage />
                  </Route>
                  <Route exact path="/token-claim-2">
                    <ClaimPage phase={2} />
                  </Route>
                </Switch>
              )}
            </div>
          </RefreshOnAccountChange>
        </Router>
        {/* <ModalContainer /> */}
      </HamburgerProvider>
    </ApolloProvider>
  )
}

export default App
